import { Component, inject, OnInit } from '@angular/core';
import { AssessmentScoreCardComponent } from '../../../dashboard/components/assessment-score-card/assessment-score-card.component';
import { CommonModule } from '@angular/common';
import { AuthService } from 'projects/patient/src/app/core/auth/services/auth.service';
import { AssesmentdetailsService } from '../../assesment-services/assesmentdetails.service';
import { ScoreHistoryResponse } from '../../assesment-const/assessment-details-models';
import { AssessmentHistoryListComponent } from '../assessment-history-list/assessment-history-list.component';
import { AssessmentHistoryGraphComponent } from "../assessment-history-graph/assessment-history-graph.component";

@Component({
  selector: 'patient-assessment-details',
  standalone: true,
  imports: [AssessmentScoreCardComponent, AssessmentHistoryListComponent, CommonModule, AssessmentHistoryGraphComponent],
  templateUrl: './assessment-details.component.html',
  styleUrl: './assessment-details.component.css',
})
export class AssessmentDetailsComponent implements OnInit {
  private authService = inject(AuthService);
  private assesmentdetailsService = inject(AssesmentdetailsService);

  patientId!: string;
  scoreHistoryData: ScoreHistoryResponse | null = null;
  loading: boolean = true;
  assessmentDetails: any = {};
  constructor() {}

  ngOnInit(): void {
    this.authService.getUserProfile().subscribe((res) => {
      if (res?.PatientId) {
        this.patientId = res.PatientId;
        this.getAssementData(this.patientId);
        this.assessmentDetails.patientID = this.patientId;
        this.assessmentDetails.isFromAppointment = false;
      }
    });
  }

  getAssementData(id: string) {
    this.loading = true;
    this.assesmentdetailsService.getScoreHistory(id).subscribe({
      next: (response) => {
        if (response && response.status === 200) {
          this.scoreHistoryData = response;
          this.assessmentDetails.assessmentID = response.pre_assessment_id;
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Failed to load score history:', err);
        this.loading = false;
      }
    });
  }
}
